import 'css-chunk:src/app/containers/Home/OrganizationsView/OrganizationsView.scss';export default {
  "OrganizationsView": "_OrganizationsView_tdi3a_1"
};